export default "__VITE_ASSET__3867d420__"